import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AgencyService } from 'src/app/services/agency.service';
import { Agencies, AgencyTier1, AgencyTier2 } from '../../models/agencies';


@Component({
    selector: 'app-agency',
    templateUrl: './agency-selection.component.html',
    standalone: false
})
export class AgencySelectionComponent implements OnInit {
  @ViewChild('fAgency', { read: NgForm }) form!: NgForm;

  onChangeSubs: Subscription[] = [];
  protected tier1Agencies: Array<AgencyTier1> = [];
  protected tier2Agencies: Array<AgencyTier2> = [];
  @Input() tier2Required = true;
  @Input() closeBtn = false;
  @Input() layout = "row"
  @Output() agencies = new EventEmitter<Agencies>();

  @Input() t1State:any = undefined;
  @Output() t1StateChange = new EventEmitter<AgencyTier1>();
  @Input() t2State:any = undefined;
  @Output() t2StateChange = new EventEmitter<AgencyTier2>();

  _tier1AgencyName?: string;
  @Input() set tier1AgencyName(name: string) {
    this._tier1AgencyName = name;
    this.setTier1AgencySelection();
  }
  get tier1AgencyName(): string|undefined {
    return this._tier1AgencyName;
  }

  _tier2AgencyName?: string;
  @Input() set tier2AgencyName(name: string) {
    this._tier2AgencyName = name;
    this.setTier2AgencySelection();
  }
  get tier2AgencyName(): string|undefined {
    return this._tier2AgencyName;
  }

  constructor(private agencyService: AgencyService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.getTier1Agencies();
    // if select being initialized, make sure it displays while loading and get T2 list
    if (this.t1State) {
      this.tier1Agencies = [this.t1State];
      this.getTier2Agencies(this.t1State.agency_Id)
    }
  }

  getTier1Agencies() {
    this.agencyService.getAgencies().subscribe(response => {
      this.tier1Agencies = response.AgencyTier1List;
      this.setTier1AgencySelection();
    });
  }

  getTier2Agencies(tier1AgencyId: number | undefined) {
    this.tier2Agencies = [];
    if (tier1AgencyId) {
      this.agencyService.getTier2Agencies(tier1AgencyId).subscribe(response => {
        this.tier2Agencies = response.tier2AgencyList == 'empty' ? [] : response.tier2AgencyList;
        this.setTier2AgencySelection();
        this.cdr.detectChanges();
      });
    }
  }

  onTier1AgencyChange() {
    const agencies: Agencies = { tier1Agency: { ...this.form.value.tier1Agency } }
    this.agencies.emit(agencies);
    this.t1StateChange.emit(this.form.value.tier1Agency)
    // changing T1, clear T2 value
    this.t2State = undefined;
    this.t2StateChange.emit(undefined)

    if (this.form.value.tier1Agency) {
      this.getTier2Agencies(this.form.value.tier1Agency.agency_Id);
    } else {
      this.tier2Agencies = [];
    }
  }

  onTier2AgencyChange() {
    // this.onTouched();
    const agencies: Agencies = { tier1Agency: { ...this.form.value.tier1Agency }, tier2Agency: { ...this.form.value.tier2Agency } };
    this.agencies.emit(agencies);
    this.t2StateChange.emit(this.form.value.tier2Agency)
  }

  onReset() {
    this.form.onReset();
    this.onTier1AgencyChange();
  }

  compareAgency(a1: AgencyTier1|AgencyTier2, a2: AgencyTier1|AgencyTier2) : boolean {
    return a1 && a2 && a1.agency_Id === a2.agency_Id;
  }

  setTier1AgencySelection() {
    if (this.tier1Agencies && this._tier1AgencyName != undefined) {
      const tier1AgencyItem = this.tier1Agencies.find(item => item.agency_Name === this._tier1AgencyName);

      if (tier1AgencyItem) {
        this.form.controls['tier1Agency'].setValue(tier1AgencyItem);
        this.getTier2Agencies(this.form.value.tier1Agency.agency_Id);
      }
    }
  }

  setTier2AgencySelection() {
    if (this.tier2Agencies && this._tier2AgencyName != undefined) {
      const tier2AgencyItem = this.tier2Agencies.find(item => item.agency_Name === this._tier2AgencyName);

      if (tier2AgencyItem) {
        setTimeout(() => {
          this.form.controls['tier2Agency'].setValue(tier2AgencyItem);
        });
      }
    }
  }

}
